import axios from 'axios';


const API_URL = process.env.VUE_APP_BASE_URL + "/el_nfse/vw_nfs_numeros";

class NfsNumeros {
  constructor() {
  }

  listarNumeros(idCliente) {
    return axios.get(API_URL + '?idCliente=' + idCliente, { headers: this.headers });
  }
}
export default new NfsNumeros();
